import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { AiFillInstagram } from 'react-icons/ai';
import { FaFacebookF, FaTwitter, FaYoutube } from 'react-icons/fa';
import IconChat from 'assets/img/icons/icon-chat.png';
import IconEmail from 'assets/img/icons/icon-email.png';
import IconReddit from 'assets/img/icons/icon-reddit.png';
import { H1, H5, Link, A } from 'components/Typography';
import Container from 'components/Container';
import Accordion from 'components/Accordion';

import {
  Warning,
  Info,
  Content,
  ContactInformation,
  FollowUsOn,
  SocialLink,
  StyledContactListItem,
  ContactIconContainer,
  IntercomLink,
  Ul,
  Li,
  Accordions,
  IconImage
} from './styled';

const ContactListItem = ({ icon, children }) => {
  return (
    <StyledContactListItem>
      <ContactIconContainer>
        <IconImage src={icon} alt="" />
      </ContactIconContainer>
      <Info>{children}</Info>
    </StyledContactListItem>
  );
};

ContactListItem.propTypes = {
  icon: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

const Contact = () => {
  return (
    <Container bg="black">
      <Helmet>
        <title>Contact us</title>
        <meta name="description" content="Get in touch with the SafetyWing team" />
      </Helmet>
      <H1>Contact us</H1>
      <Content>
        <ContactInformation>
          <Warning>
            IN CASE OF A MEDICAL EMERGENCY, CALL 911 OR THE EQUIVALENT OF THE COUNTRY YOU
            ARE IN.
          </Warning>

          <Accordions>
            <Accordion title="Nomad Insurance" description="">
              <Ul>
                <Li>
                  Contact us through the{' '}
                  <IntercomLink onClick={() => window.Intercom('showNewMessage')}>
                    live chat
                  </IntercomLink>{' '}
                  to get a response in under a minute
                </Li>
                <Li>
                  Email us at{' '}
                  <A href="mailto:support@safetywing.com">support@safetywing.com</A>
                </Li>
                <Li>
                  Refer to the insurance card located in your{' '}
                  <Link to="/nomad-insurance/profile">member dashboard</Link>.
                </Li>
              </Ul>
            </Accordion>
            <Accordion title="Remote Health">
              <Info>
                For 24/7 assistance, contact us through the{' '}
                <IntercomLink onClick={() => window.Intercom('showNewMessage')}>
                  live chat
                </IntercomLink>{' '}
                to get a response in under a minute
              </Info>
            </Accordion>
          </Accordions>

          <ContactListItem icon={IconChat}>
            Contact us on our{' '}
            <IntercomLink onClick={() => window.Intercom('showNewMessage')}>
              customer service chat
            </IntercomLink>{' '}
            in the lower right corner for questions regarding the policy, technical
            support or to give us feedback.
          </ContactListItem>

          <ContactListItem icon={IconEmail}>
            You can also email us on{' '}
            <A href="mailto:support@safetywing.com">support@safetywing.com</A> with
            questions regarding the policy, technical support or to give us feedback.
          </ContactListItem>

          <ContactListItem icon={IconReddit}>
            We are active on <A href="https://www.reddit.com/r/safetywing/">reddit</A>,
            and happy to answer your questions on our subreddit. Feel free to subscribe,
            engage with the founders and contribute suggestions.
          </ContactListItem>
        </ContactInformation>

        <FollowUsOn>
          <H5>Follow us on</H5>
          <SocialLink href="https://www.facebook.com/safetywing/">
            <FaFacebookF />
            Facebook
          </SocialLink>
          <SocialLink href="https://twitter.com/safetywing">
            <FaTwitter />
            Twitter
          </SocialLink>
          <SocialLink href="https://www.instagram.com/safetywing">
            <AiFillInstagram />
            Instagram
          </SocialLink>
          <SocialLink href="https://www.youtube.com/channel/UCotagRRzqxRZ4nAECs6vASQ/">
            <FaYoutube />
            YouTube
          </SocialLink>
        </FollowUsOn>
      </Content>
    </Container>
  );
};

export default Contact;
